<template>
  <el-dialog title="设置波特率" :visible.sync="baudVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false" center>
    <div class="from-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto" class="demo-ruleForm">
        <el-form-item label="通讯波特率" prop="baudRate">
          <el-input v-model="ruleForm.baudRate" style="width:300px;"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        baudRate: null,
        address: null
      },
      rules: {
        baudRate: [
          {
            required: true,
            message: "请设置波特率",
            trigger: "blur",
          }
        ],
      }
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["baudVisible","gateway","baudRate","address"],
  watch: {
    baudVisible(newValue) {
      if (newValue) {
        this.ruleForm.baudRate=this.baudRate;
        this.ruleForm.address=this.address;
      }
    },
  },
  methods: {
    onInput() {
      this.$forceUpdate();
    },
    handleClose() {
      this.ruleForm = {
        baudRate: null,
        address: null,
      };
      this.$emit("handleClose");
    },
    submit() {
      if (this.ruleForm.baudRate==null||this.ruleForm.baudRate=="") {
        this.$message.error("请设置波特率");
        return;
      } 
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          var param={
            "gateway": this.gateway,
            "baudRate": this.ruleForm.baudRate,
            "address": this.ruleForm.address,
          };
          this.request.baudRate(param).then((res) => {
            if (res.code==0) {
              this.$message.success("修改成功");
              this.handleClose();
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.from-body {
  padding: 0 60px;
  box-sizing: border-box;
}
</style>